import { Suspense, useState } from "react"
import classNames from "classnames"
import ObjectOverview from "./ObjectOverview"
import ActionPanel from "web/app/Deals/ViewDeal/ActionPanel/ActionPanel"

import { Radio } from "web/components/Form/Controls"
import { Loading } from "web/components"

const MODES = [
  { value: "Actions", label: "Actions" },
  { value: "Summary", label: "Summary" },
]

export default function DealOverview() {
  const [mode, setMode] = useState(MODES[0])

  const objectOverviewClasses = classNames("lg:col-span-2 lg:block", {
    block: mode.value === "Summary",
    hidden: mode.value !== "Summary",
  })
  const actionPanelClasses = classNames("lg:block", {
    block: mode.value === "Actions",
    hidden: mode.value !== "Actions",
  })

  return (
    <div>
      <div
        style={{ width: "200px" }}
        className="mx-auto mb-2 rounded-md border p-1 lg:hidden"
      >
        <Radio lookup_values={MODES} value={mode} onChange={setMode} />
      </div>
      <div className="max-w-[1640px] gap-x-3 lg:grid lg:grid-cols-3">
        <div className={objectOverviewClasses}>
          <Suspense fallback={<Loading inline />}>
            <ObjectOverview />
          </Suspense>
        </div>
        <div className={actionPanelClasses}>
          <ActionPanel />
        </div>
      </div>
    </div>
  )
}
